import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Fonts: serif = optical-size + weight axes with a true italic (the prototype
// faked the italic; HANDOFF 1.2 asks for the real one), sans = weight axis,
// mono = 500 only.
import '@fontsource-variable/source-serif-4/opsz.css';
import '@fontsource-variable/source-serif-4/opsz-italic.css';
import '@fontsource-variable/source-sans-3/wght.css';
import '@fontsource/ibm-plex-mono/500.css';
import './index.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
